import i18n from './config'
import Link from './Link'

const languages = [ 'de', 'fr' ]

export { Link, languages }
export default i18n
